class StickyAddToCart {
  constructor() {
    this.stickyBar = document.querySelector('[data-sticky-atc]');
    if (!this.stickyBar) return;

    this.mainATCButton = document.querySelector('.product_form .add_to_cart');
    this.mainForm = document.querySelector('[data-product-form]:not([data-sticky-form])');
    this.stickyForm = document.querySelector('[data-sticky-form]');
    this.stickyButton = document.querySelector('[data-sticky-add-to-cart]');
    this.productId = this.stickyForm?.dataset.productId;
    
    this.mainVariantInput = this.mainForm?.querySelector('input[name="id"]') || 
                           this.mainForm?.querySelector('select[name="id"]') ||
                           document.querySelector('.product_form input[name="id"]') ||
                           document.querySelector('.product_form select[name="id"]');
    
    this.variantRadios = document.querySelector('variant-radios');
    this.stickyVariantSelect = this.stickyForm?.querySelector('[data-sticky-variant-select]');
    this.mainQuantityInput = this.mainForm?.querySelector('input[name="quantity"]');
    this.stickyQuantityInput = this.stickyForm?.querySelector('[data-sticky-quantity]');
    this.stickyProductImage = document.querySelector('[data-sticky-product-image]');
    this.stickyPrice = document.querySelector('[data-sticky-price] .money');
    this.stickyComparePrice = document.querySelector('[data-sticky-compare-price]');
    
    this.mainSellingPlanInput = this.mainForm?.querySelector('input[name="selling_plan"]') ||
                                document.querySelector('.product_form input[name="selling_plan"]') ||
                                document.querySelector('.shopify-product-form input[name="selling_plan"]');
    this.stickySellingPlanInput = this.stickyForm?.querySelector('[data-sticky-selling-plan]');
    
    this.init();
  }

  init() {
    this.setupIntersectionObserver();
    this.setupVariantSync();
    this.setupMetafieldVariantSync();
    this.setupQuantitySync();
    this.setupReviewsScroll();
    this.setupPriceObserver();
    this.setupRechargeWidget();
    this.updatePriceFromMainForm();
    this.hideEmptyReviews();
    
    requestAnimationFrame(() => {
      this.stickyBar.classList.add('is-ready');
    });
  }

  setupIntersectionObserver() {
    if (!this.mainATCButton || !this.stickyBar) return;

      const headerWrapper = document.querySelector('.header-wrapper');
      const header = document.querySelector('header.header');
      const topBar = document.querySelector('.top-bar');
      
    const getHeaderHeight = () => {
      let totalHeight = 0;
      
      if (topBar && window.getComputedStyle(topBar).display !== 'none') {
        totalHeight += topBar.offsetHeight;
      }
      
      if (headerWrapper) {
        totalHeight += headerWrapper.offsetHeight;
      } else if (header) {
        totalHeight += header.offsetHeight;
      }
      
      return totalHeight || 0;
    };

    const getStickyBarHeight = () => {
      return this.stickyBar ? this.stickyBar.offsetHeight : 0;
    };

    let currentHeaderHeight = getHeaderHeight();
    let currentStickyBarHeight = getStickyBarHeight();
    let isStickyVisible = false;
    const createObserver = () => {
      const rootMarginValue = Math.max(0, currentHeaderHeight - currentStickyBarHeight);
      
      return new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const isScrolledPast = entry.boundingClientRect.top < 0;
          
          if (entry.isIntersecting || !isScrolledPast) {
            if (isStickyVisible) {
            this.hideStickyBar();
              isStickyVisible = false;
            }
          } else {
            if (!isStickyVisible) {
            this.showStickyBar();
              isStickyVisible = true;
            }
          }
        });
      }, {
        root: null,
        threshold: 0,
        rootMargin: `-${rootMarginValue}px 0px 0px 0px`
      });
    };

    this.intersectionObserver = createObserver();
    this.intersectionObserver.observe(this.mainATCButton);

    const checkScrollPosition = () => {
      if (!this.mainATCButton) return;
      const rect = this.mainATCButton.getBoundingClientRect();
      const isScrolledPast = rect.top < 0;
      
      if (isScrolledPast && !isStickyVisible) {
        this.showStickyBar();
        isStickyVisible = true;
      } else if (!isScrolledPast && isStickyVisible) {
        this.hideStickyBar();
        isStickyVisible = false;
      }
    };

    let scrollTimeout;
    const scrollHandler = () => {
      if (scrollTimeout) {
        cancelAnimationFrame(scrollTimeout);
      }
      scrollTimeout = requestAnimationFrame(checkScrollPosition);
    };

    window.addEventListener('scroll', scrollHandler, { passive: true });
    this.scrollHandler = scrollHandler;
    
    requestAnimationFrame(checkScrollPosition);

    let resizeTimeout;
    const resizeHandler = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const newHeaderHeight = getHeaderHeight();
        const newStickyBarHeight = getStickyBarHeight();
        if (newHeaderHeight !== currentHeaderHeight || newStickyBarHeight !== currentStickyBarHeight) {
          currentHeaderHeight = newHeaderHeight;
          currentStickyBarHeight = newStickyBarHeight;
          this.intersectionObserver.disconnect();
          this.intersectionObserver = createObserver();
          this.intersectionObserver.observe(this.mainATCButton);
        }
        checkScrollPosition();
      }, 100);
    };

    window.addEventListener('resize', resizeHandler);
    this.resizeHandler = resizeHandler;
  }

  showStickyBar() {
    this.stickyBar.classList.add('is-visible');
    this.stickyBar.setAttribute('aria-hidden', 'false');
  }

  hideStickyBar() {
    this.stickyBar.classList.remove('is-visible');
    this.stickyBar.setAttribute('aria-hidden', 'true');
  }

  setupVariantSync() {
    if (!this.stickyVariantSelect) return;

    if (this.mainVariantInput) {
      this.mainVariantInput.addEventListener('change', (e) => {
        const selectedValue = e.target.value;
        if (this.stickyVariantSelect.tagName === 'SELECT') {
          if (this.stickyVariantSelect.value !== selectedValue) {
            this.stickyVariantSelect.value = selectedValue;
          }
        } else if (this.stickyVariantSelect.tagName === 'INPUT') {
          this.stickyVariantSelect.value = selectedValue;
        }
        this.updateStickyProductInfo(selectedValue);
        
        setTimeout(() => {
          const urlParams = new URLSearchParams(window.location.search);
          const variantIdFromURL = urlParams.get('variant');
          if (variantIdFromURL && variantIdFromURL !== selectedValue && this.stickyVariantSelect.tagName === 'SELECT') {
            if (this.stickyVariantSelect.value !== variantIdFromURL) {
              this.stickyVariantSelect.value = variantIdFromURL;
              this.updateStickyProductInfo(variantIdFromURL);
            }
          }
        }, 100);
      });
    }

    if (this.variantRadios) {
      this.variantRadios.addEventListener('change', () => {
        let variantId = null;
        
        if (this.mainVariantInput) {
          variantId = this.mainVariantInput.value;
        } else {
          const formInput = this.mainForm?.querySelector('input[name="id"]') || 
                          document.querySelector('.product_form input[name="id"]');
          if (formInput) {
            variantId = formInput.value;
          }
        }
        
        const urlParams = new URLSearchParams(window.location.search);
        const variantFromURL = urlParams.get('variant');
        if (variantFromURL) {
          variantId = variantFromURL;
        }
        
        if (variantId && this.stickyVariantSelect) {
          if (this.stickyVariantSelect.tagName === 'SELECT') {
            if (this.stickyVariantSelect.value !== variantId) {
              this.stickyVariantSelect.value = variantId;
            }
          } else if (this.stickyVariantSelect.tagName === 'INPUT') {
            this.stickyVariantSelect.value = variantId;
          }
          this.updateStickyProductInfo(variantId);
        }
      });
    }


    if (this.stickyVariantSelect.tagName === 'SELECT') {
      this.stickyVariantSelect.addEventListener('change', (e) => {
        const selectedValue = e.target.value;
        const selectedOption = this.stickyVariantSelect.querySelector(`option[value="${selectedValue}"]`);
        if (!selectedOption) return;
        
        const variantTitle = selectedOption.textContent.trim();
        const mainVariantElement = this.mainVariantInput || 
                                  this.mainForm?.querySelector('input[name="id"]') ||
                                  this.mainForm?.querySelector('select[name="id"]') ||
                                  document.querySelector('.product_form input[name="id"]') ||
                                  document.querySelector('.product_form select[name="id"]');
        
        if (mainVariantElement) {
          if (mainVariantElement.value !== selectedValue) {
            mainVariantElement.value = selectedValue;
            mainVariantElement.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
            
            if (typeof jQuery !== 'undefined' && jQuery) {
              jQuery(mainVariantElement).trigger('change');
            }
            
            document.dispatchEvent(new CustomEvent('product-info:variant-changed', {
              detail: { variantId: selectedValue }
            }));
            
            const swatchOptions = this.mainForm?.querySelector('.swatch_options');
            if (swatchOptions) {
              const productData = this.stickyForm?.dataset.product;
              let variant = null;
              
              if (productData) {
                try {
                  const product = JSON.parse(productData);
                  variant = product.variants?.find(v => v.id.toString() === selectedValue.toString());
                } catch (e) {}
              }
              
              if (variant && variant.options) {
                variant.options.forEach((optionValue, index) => {
                  const swatch = swatchOptions.querySelector(
                    `.swatch[data-option-index="${index}"] .swatch-element[data-value="${optionValue}"]`
                  );
                  
                  if (swatch) {
                    const allSwatchesInGroup = swatchOptions.querySelectorAll(
                      `.swatch[data-option-index="${index}"] .swatch-element`
                    );
                    allSwatchesInGroup.forEach(s => s.classList.remove('selected'));
                    
                    swatch.classList.add('selected');
                    
                    const radioInput = swatch.querySelector('input[type="radio"]');
                    if (radioInput) {
                      radioInput.checked = true;
                      radioInput.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                    
                    if (typeof jQuery !== 'undefined' && jQuery) {
                      jQuery(swatch).trigger('click');
                    }
                  }
                });
              }
            }
            
            if (window.gallerySliders && typeof window.gallerySliders.updateVariantSelectorStyles === 'function') {
              setTimeout(() => {
                window.gallerySliders.updateVariantSelectorStyles();
              }, 50);
            }
          }
        }
        
        if (this.variantRadios) {
          this.updateVariantRadiosFromVariantId(selectedValue, variantTitle);
          setTimeout(() => {
            window.dispatchEvent(new CustomEvent('variant:change', {
              detail: { variant: selectedValue }
            }));
            
            if (this.variantRadios.onVariantChange) {
              this.variantRadios.onVariantChange();
            }
          }, 100);
        } else {
          this.updateURL(selectedValue);
        }
        
        this.updateStickyProductInfo(selectedValue);
      });
    }

    let lastVariantInURL = new URLSearchParams(window.location.search).get('variant');
    
    const checkURLChange = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const variantIdFromURL = urlParams.get('variant');
      
      if (variantIdFromURL !== lastVariantInURL) {
        lastVariantInURL = variantIdFromURL;
      
      if (variantIdFromURL) {
        if (this.stickyVariantSelect && this.stickyVariantSelect.tagName === 'SELECT') {
          if (this.stickyVariantSelect.value !== variantIdFromURL) {
            this.stickyVariantSelect.value = variantIdFromURL;
              this.updateStickyProductInfo(variantIdFromURL);
            }
          }
        }
      }
    };

    const handleURLChange = () => {
      checkURLChange();
    };

    window.addEventListener('popstate', handleURLChange);
    this.urlChangeHandler = handleURLChange;
    
    const originalReplaceState = window.history.replaceState;
    const originalPushState = window.history.pushState;
    
    window.history.replaceState = function(...args) {
      originalReplaceState.apply(window.history, args);
      setTimeout(checkURLChange, 0);
    };
    
    window.history.pushState = function(...args) {
      originalPushState.apply(window.history, args);
      setTimeout(checkURLChange, 0);
    };
    
    this._originalReplaceState = originalReplaceState;
    this._originalPushState = originalPushState;

    const urlParams = new URLSearchParams(window.location.search);
    const variantIdFromURL = urlParams.get('variant');
    
    if (variantIdFromURL) {
      if (this.stickyVariantSelect && this.stickyVariantSelect.tagName === 'SELECT') {
        if (this.stickyVariantSelect.value !== variantIdFromURL) {
          this.stickyVariantSelect.value = variantIdFromURL;
        }
      }
      this.updateStickyProductInfo(variantIdFromURL);
    }
  }

  updateVariantRadiosFromVariantId(variantId, variantTitle) {
    if (!this.variantRadios) return;
    
    const variantData = this.getVariantData();
    if (!variantData) return;
    
    const variant = variantData.find(v => v.id === parseInt(variantId));
    if (!variant) return;
    
    const fieldsets = this.variantRadios.querySelectorAll('fieldset');
    
    fieldsets.forEach((fieldset, index) => {
      const optionValue = variant[`option${index + 1}`];
      if (!optionValue) return;
      
      const radioInput = fieldset.querySelector(`input[type="radio"][value="${CSS.escape(optionValue)}"]`);
      
      if (radioInput && !radioInput.checked) {
        radioInput.checked = true;
        radioInput.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
      }
    });
  }
  
  getVariantData() {
    if (!this.variantRadios) return null;
    
    const jsonEl = this.variantRadios.querySelector('[type="application/json"]');
    if (!jsonEl || !jsonEl.textContent) return null;
    
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

  updateURL(variantId) {
    if (this.variantRadios) return;
    
    const productUrl = this.stickyForm?.dataset.url || window.location.pathname;
    const newURL = `${productUrl}?variant=${variantId}`;
    
    try {
      window.history.replaceState({}, '', newURL);
    } catch (error) {}
  }

  updateStickyProductInfo(variantId) {
    if (!this.stickyVariantSelect) return;
    
    let selectedOption = null;
    if (this.stickyVariantSelect.tagName === 'SELECT') {
      selectedOption = this.stickyVariantSelect.querySelector(`option[value="${variantId}"]`);
      if (!selectedOption) return;
      
      if (this.stickyVariantSelect.value !== variantId) {
        this.stickyVariantSelect.value = variantId;
      }
    } else {
      return;
    }
    
    if (!selectedOption) return;

    const variantImage = selectedOption.dataset.image;
    if (variantImage && this.stickyProductImage) {
      this.stickyProductImage.src = variantImage;
      this.stickyProductImage.srcset = `${variantImage} 1x, ${variantImage.replace('.jpg', '_2x.jpg')} 2x`;
    }

    const price = selectedOption.dataset.price;
    const comparePrice = selectedOption.dataset.comparePrice;
    const isSubscriptionActive = this.isSubscriptionActive();
    
    if (!isSubscriptionActive && price && this.stickyPrice) {
      const formattedPrice = this.formatMoney(price);
      this.stickyPrice.textContent = formattedPrice;
    }

    if (this.stickyComparePrice) {
      if (comparePrice && parseInt(comparePrice) > parseInt(price)) {
        this.stickyComparePrice.style.display = '';
        const comparePriceMoney = this.stickyComparePrice.querySelector('.money');
        if (comparePriceMoney) {
          comparePriceMoney.textContent = this.formatMoney(comparePrice);
        }
      } else {
        this.stickyComparePrice.style.display = 'none';
      }
    }
  }

  isSubscriptionActive() {
    if (!this._stickyRechargeContainer) {
      this._stickyRechargeContainer = document.querySelector('[data-sticky-recharge-widget]');
    }
    if (!this._stickyRechargeContainer) return false;
    
    const subscribeOption = this._stickyRechargeContainer.querySelector('.rc-option.rc-option--active:not(:has(.rc_widget__option__input--onetime))');
    return !!subscribeOption;
  }

  updatePriceForPurchaseType(isOnetime) {
    if (isOnetime) {
      const variantSelect = this.stickyVariantSelect;
      let variantPrice = null;
      
      if (variantSelect) {
        if (variantSelect.tagName === 'SELECT') {
          const selectedOption = variantSelect.options[variantSelect.selectedIndex];
          variantPrice = selectedOption?.dataset.price;
        } else if (variantSelect.tagName === 'INPUT') {
          const variantId = variantSelect.value;
          
          if (!this._mainVariantSelect) {
            this._mainVariantSelect = document.querySelector('.product_form select[name="id"]');
          }
          
          if (this._mainVariantSelect) {
            const option = this._mainVariantSelect.querySelector(`option[value="${variantId}"]`);
            variantPrice = option?.dataset.price;
          }
          
          if (!variantPrice && this.stickyForm) {
            const productData = this.stickyForm.dataset.product;
            if (productData) {
              try {
                const product = JSON.parse(productData);
                const variant = product.variants?.find(v => v.id.toString() === variantId);
                variantPrice = variant?.price;
              } catch (e) {}
            }
          }
        }
        
        if (variantPrice && this.stickyPrice) {
          const formattedPrice = this.formatMoney(variantPrice);
          this.stickyPrice.textContent = formattedPrice;
        } else {
          if (!this._mainPriceElement) {
            this._mainPriceElement = document.querySelector('.product_form .current_price .money, .product_form [data-price] .money');
          }
          if (this._mainPriceElement && this.stickyPrice) {
            this.stickyPrice.textContent = this._mainPriceElement.textContent;
          }
        }
      }
    } else {
      if (!this._stickyRechargeContainer) {
        this._stickyRechargeContainer = document.querySelector('[data-sticky-recharge-widget]');
      }
      const checkedRadio = this._stickyRechargeContainer?.querySelector('.cc-rc-plans-radios__input:checked');
      
      if (checkedRadio && checkedRadio.dataset.optionPrice && this.stickyPrice) {
        this.stickyPrice.textContent = checkedRadio.dataset.optionPrice;
      }
    }
  }

  setupMetafieldVariantSync() {
    const metafieldVariantSelect = this.stickyForm?.querySelector('[data-metafield-variant-select]') ||
                                   document.querySelector('.sticky-atc [data-metafield-variant-select]') ||
                                   document.querySelector('.sticky-metafield-variant-select');
    
    if (!metafieldVariantSelect) return;
    
    metafieldVariantSelect.addEventListener('change', (e) => {
      const selectedUrl = e.target.value;
      if (selectedUrl) {
        window.location.href = selectedUrl;
      }
    });
  }

  setupSellingPlanSync() {
    if (!this.mainSellingPlanInput || !this.stickySellingPlanInput) return;
    
    // Listen for direct changes to the main selling_plan input
    this.mainSellingPlanInput.addEventListener('change', () => {
      const mainValue = this.mainSellingPlanInput.value;
      if (mainValue !== this.stickySellingPlanInput.value) {
        this.stickySellingPlanInput.value = mainValue;
      }
    });
    
    // Also use MutationObserver to catch programmatic value changes
    let lastMainValue = this.mainSellingPlanInput.value;
    const checkMainSellingPlan = () => {
      if (this.mainSellingPlanInput && this.stickySellingPlanInput) {
        const currentMainValue = this.mainSellingPlanInput.value;
        if (currentMainValue !== lastMainValue) {
          lastMainValue = currentMainValue;
          if (currentMainValue !== this.stickySellingPlanInput.value) {
            this.stickySellingPlanInput.value = currentMainValue;
          }
        }
      }
    };
    
    // Check periodically for value changes (in case Recharge widget updates it programmatically)
    this.sellingPlanCheckInterval = setInterval(checkMainSellingPlan, 100);
  }

  setupRechargeWidget() {
    const stickyRechargeSelect = document.querySelector('[data-sticky-recharge-select]');
    const rechargeContainer = document.querySelector('.sticky-atc__recharge-container');
    
    if (!stickyRechargeSelect) {
      if (rechargeContainer) {
        rechargeContainer.style.display = 'none';
      }
      return;
    }
    
    this.setupSellingPlanSync();
    this.setupCustomRechargeRadioSync();
    
    const checkAndBuildWidget = () => {
      const mainRcSellingPlans = document.querySelector('.shopify-product-form .rc-selling-plans');
      const mainRcOptions = document.querySelectorAll('.shopify-product-form .rc-option');
      const mainSubscribeOption = Array.from(mainRcOptions).find(opt => 
        !opt.classList.contains('rc-option__onetime')
      );
      
      if (mainRcSellingPlans && mainRcOptions.length > 0 && mainSubscribeOption) {
        if (this.rechargeObserver) {
          this.rechargeObserver.disconnect();
          this.rechargeObserver = null;
        }
        
        if (this.rechargeTimeout) {
          clearTimeout(this.rechargeTimeout);
          this.rechargeTimeout = null;
        }

        if (this.rechargeRetryInterval) {
          clearInterval(this.rechargeRetryInterval);
          this.rechargeRetryInterval = null;
        }
        
        const mainSelect = mainRcSellingPlans.querySelector('select');
        const mainOnetimeOption = Array.from(mainRcOptions).find(opt => 
          opt.classList.contains('rc-option__onetime')
        );
        
        if (!mainSelect || !mainOnetimeOption) {
          return false;
        }
        
        const dropdownOptions = [];
        
        dropdownOptions.push({
          value: 'onetime',
          label: 'Buy once',
          type: 'onetime'
        });
        
        if (mainSelect.options.length > 0) {
          Array.from(mainSelect.options).forEach((option, index) => {
            if (option.value) {
              dropdownOptions.push({
                value: option.value,
                label: option.textContent.trim(),
                type: 'subscription',
                index: index
              });
            }
          });
        }
        
        stickyRechargeSelect.innerHTML = '';
        dropdownOptions.forEach(option => {
          const optionEl = document.createElement('option');
          optionEl.value = option.value;
          optionEl.textContent = option.label;
          optionEl.setAttribute('data-type', option.type);
          if (option.type === 'subscription') {
            optionEl.setAttribute('data-index', option.index);
          }
          stickyRechargeSelect.appendChild(optionEl);
        });
        
        rechargeContainer.style.display = 'block';
        stickyRechargeSelect.disabled = false;
        
        let isSyncing = false;
        
        stickyRechargeSelect.addEventListener('change', (e) => {
          if (isSyncing) return;
          isSyncing = true;
          
          const selectedOption = e.target.selectedOptions[0];
          const optionType = selectedOption.getAttribute('data-type');
          let mainSubscribeRadio = null;
          
          if (optionType === 'onetime') {
            if (this.stickySellingPlanInput) {
              this.stickySellingPlanInput.value = '';
            }
            if (this.mainSellingPlanInput) {
              this.mainSellingPlanInput.value = '';
            }
            
            if (mainOnetimeOption) {
              const mainOnetimeRadio = mainOnetimeOption.querySelector('input[type="radio"]');
              if (mainOnetimeRadio && !mainOnetimeRadio.checked) {
                mainOnetimeRadio.checked = true;
                mainOnetimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
            
            setTimeout(() => {
              this.updatePriceFromMainForm();
            }, 150);
          } else if (optionType === 'subscription') {
            if (mainSubscribeOption && mainSelect) {
              mainSubscribeRadio = mainSubscribeOption.querySelector('input[type="radio"]');
              const planValue = e.target.value;
              
              // Set selling_plan in both forms
              if (this.mainSellingPlanInput) {
                this.mainSellingPlanInput.value = planValue;
              }
              if (this.stickySellingPlanInput) {
                this.stickySellingPlanInput.value = planValue;
              }
              
              if (mainSubscribeRadio && !mainSubscribeRadio.checked) {
                const clickableElement = mainSubscribeOption.querySelector('label, .rc_widget__option__label, .rc-option');
                if (clickableElement) {
                  clickableElement.click();
                } else {
                  mainSubscribeRadio.checked = true;
                  mainSubscribeRadio.dispatchEvent(new Event('change', { bubbles: true }));
                }
                
                setTimeout(() => {
                  if (mainSelect.value !== planValue) {
                    const optionToSelect = Array.from(mainSelect.options).find(opt => opt.value === planValue);
                    if (optionToSelect) {
                      mainSelect.value = planValue;
                      mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                  }
                  
                  setTimeout(() => {
                    if (this.mainSellingPlanInput && this.stickySellingPlanInput) {
                      const mainSellingPlanValue = this.mainSellingPlanInput.value;
                      if (mainSellingPlanValue && mainSellingPlanValue !== this.stickySellingPlanInput.value) {
                        this.stickySellingPlanInput.value = mainSellingPlanValue;
                      }
                    }
                    this.updatePriceFromMainForm();
                  }, 100);
                }, 150);
              } else {
                if (mainSelect.value !== planValue) {
                  const optionToSelect = Array.from(mainSelect.options).find(opt => opt.value === planValue);
                  if (optionToSelect) {
                    mainSelect.value = planValue;
                    mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                }
                
                setTimeout(() => {
                  if (this.mainSellingPlanInput && this.stickySellingPlanInput) {
                    const mainSellingPlanValue = this.mainSellingPlanInput.value;
                    if (mainSellingPlanValue && mainSellingPlanValue !== this.stickySellingPlanInput.value) {
                      this.stickySellingPlanInput.value = mainSellingPlanValue;
                    }
                  }
                  this.updatePriceFromMainForm();
                }, 100);
              }
            }
          }
          
          const syncTimeout = optionType === 'subscription' && !mainSubscribeRadio?.checked ? 300 : 100;
          setTimeout(() => { isSyncing = false; }, syncTimeout);
        });
        
        return true;
      }
      
      return false;
    };
    
    if (checkAndBuildWidget()) {
      return;
    }
    
    const productFormContainer = document.querySelector('.shopify-product-form') || 
                                 document.querySelector('.product_form') ||
                                 document.body;
    
    if (productFormContainer) {
      this.rechargeObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            if (checkAndBuildWidget()) {
              return;
            }
          }
        }
      });
      
      this.rechargeObserver.observe(productFormContainer, {
        childList: true,
        subtree: true
      });
    }
    
    this.rechargeTimeout = setTimeout(() => {
      if (this.rechargeObserver) {
        this.rechargeObserver.disconnect();
        this.rechargeObserver = null;
      }
      
      if (!checkAndBuildWidget() && rechargeContainer) {
        const checkRechargeAPI = () => {
          return window.ReChargeWidget && typeof window.ReChargeWidget.getWidgets === 'function';
        };
        
        let attempts = 0;
        const maxAttempts = 60;
        const startTime = Date.now();
        const maxWaitTime = 30000;
        
        this.rechargeRetryInterval = setInterval(() => {
          attempts++;
          const elapsed = Date.now() - startTime;
          
          if (elapsed > maxWaitTime || attempts > maxAttempts) {
            if (this.rechargeRetryInterval) {
              clearInterval(this.rechargeRetryInterval);
              this.rechargeRetryInterval = null;
            }
            if (!checkAndBuildWidget() && rechargeContainer) {
              rechargeContainer.style.display = 'none';
            }
            return;
          }
          
          if (checkRechargeAPI() || checkAndBuildWidget()) {
            if (this.rechargeRetryInterval) {
              clearInterval(this.rechargeRetryInterval);
              this.rechargeRetryInterval = null;
            }
            return;
          }
        }, 500);
        }
    }, 10000);
  }

  setupCustomRechargeRadioSync() {
    const stickyRechargeSelect = document.querySelector('[data-sticky-recharge-select]');
    if (!stickyRechargeSelect) return;
    
    const watchForRadios = () => {
      const mainRadios = document.querySelectorAll('.shopify-product-form .cc-rc-plans-radios__input');
      const mainRcOptions = document.querySelectorAll('.shopify-product-form .rc-option');
      
      if (mainRadios.length > 0 && mainRcOptions.length > 0) {
        
        if (this.customRechargeObserver) {
          this.customRechargeObserver.disconnect();
          this.customRechargeObserver = null;
        }
        
        const dropdownOptions = [];
        
        dropdownOptions.push({
          value: 'onetime',
          label: 'Buy once',
          type: 'onetime'
        });
        
        mainRadios.forEach((radio) => {
          const labelElement = radio.nextElementSibling?.querySelector('.cc-rc-plans-radios__input-text');
          let labelText = 'Subscribe';
          
          if (labelElement) {
            const clone = labelElement.cloneNode(true);
            const dailyPriceSpan = clone.querySelector('.cc-rc-plans-radios__input-text--daily-price');
            if (dailyPriceSpan) {
              dailyPriceSpan.remove();
            }
            labelText = clone.textContent?.trim() || 'Subscribe';
          }
          
          dropdownOptions.push({
            value: radio.value,
            label: labelText,
            type: 'subscription',
            price: radio.dataset.optionPrice
      });
    });

        stickyRechargeSelect.innerHTML = '';
        dropdownOptions.forEach(option => {
          const optionEl = document.createElement('option');
          optionEl.value = option.value;
          optionEl.textContent = option.label;
          optionEl.setAttribute('data-type', option.type);
          if (option.price) {
            optionEl.setAttribute('data-price', option.price);
          }
          stickyRechargeSelect.appendChild(optionEl);
        });
        
        const rechargeContainer = document.querySelector('.sticky-atc__recharge-container');
        if (rechargeContainer) {
          rechargeContainer.style.display = 'block';
        }
        
        this.setupCustomRadioToDropdownSync(mainRadios, mainRcOptions);
        this.setupDropdownToCustomRadioSync(mainRadios, mainRcOptions);
        
        return true;
      }
      
      return false;
    };
    
    if (watchForRadios()) return;
    
    const productFormContainer = document.querySelector('.shopify-product-form') || 
                                 document.querySelector('.product_form') ||
                                 document.body;
    
    if (productFormContainer) {
      this.customRechargeObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            if (watchForRadios()) return;
          }
        }
      });
      
      this.customRechargeObserver.observe(productFormContainer, {
        childList: true,
        subtree: true
      });
      
      setTimeout(() => {
        if (this.customRechargeObserver) {
          this.customRechargeObserver.disconnect();
          this.customRechargeObserver = null;
        }
      }, 5000);
    }
  }

  setupCustomRadioToDropdownSync(mainRadios, mainRcOptions) {
    const stickyRechargeSelect = document.querySelector('[data-sticky-recharge-select]');
    if (!stickyRechargeSelect) return;
    
    mainRadios.forEach((radio) => {
      radio.addEventListener('change', (e) => {
        const selectedValue = e.target.value;
        
        if (stickyRechargeSelect.value !== selectedValue) {
          stickyRechargeSelect.value = selectedValue;
        }
        
        if (this.mainSellingPlanInput) {
          this.mainSellingPlanInput.value = selectedValue;
        }
        if (this.stickySellingPlanInput) {
          this.stickySellingPlanInput.value = selectedValue;
        }
        
        setTimeout(() => {
          if (this.mainSellingPlanInput && this.stickySellingPlanInput) {
            const mainValue = this.mainSellingPlanInput.value;
            if (mainValue && mainValue !== this.stickySellingPlanInput.value) {
              this.stickySellingPlanInput.value = mainValue;
            }
          }
          this.updatePriceFromMainForm();
        }, 100);
      });
    });
    
    mainRcOptions.forEach((option) => {
      option.addEventListener('click', () => {
        setTimeout(() => {
          const isOnetime = option.querySelector('.rc_widget__option__input--onetime');
          
          if (isOnetime && option.classList.contains('rc-option--active')) {
            if (stickyRechargeSelect.value !== 'onetime') {
              stickyRechargeSelect.value = 'onetime';
            }
            if (this.mainSellingPlanInput) {
              this.mainSellingPlanInput.value = '';
            }
            if (this.stickySellingPlanInput) {
              this.stickySellingPlanInput.value = '';
            }
          } else if (!isOnetime && option.classList.contains('rc-option--active')) {
            const firstSubscriptionOption = stickyRechargeSelect.querySelector('option[data-type="subscription"]');
            if (firstSubscriptionOption && stickyRechargeSelect.value !== firstSubscriptionOption.value) {
              stickyRechargeSelect.value = firstSubscriptionOption.value;
            }
            
            const planValue = firstSubscriptionOption ? firstSubscriptionOption.value : null;
            const selectedRadio = document.querySelector('.shopify-product-form .cc-rc-plans-radios__input:checked');
            const sellingPlanValue = selectedRadio && selectedRadio.value ? selectedRadio.value : planValue;
            
            if (sellingPlanValue) {
              if (this.mainSellingPlanInput) {
                this.mainSellingPlanInput.value = sellingPlanValue;
              }
              if (this.stickySellingPlanInput) {
                this.stickySellingPlanInput.value = sellingPlanValue;
              }
            } else {
              setTimeout(() => {
                if (this.mainSellingPlanInput && this.stickySellingPlanInput) {
                  const mainValue = this.mainSellingPlanInput.value;
                  if (mainValue && mainValue !== this.stickySellingPlanInput.value) {
                    this.stickySellingPlanInput.value = mainValue;
                  }
                }
              }, 150);
            }
          }
          
          this.updatePriceFromMainForm();
        }, 50);
      });
    });
  }

  setupDropdownToCustomRadioSync(mainRadios, mainRcOptions) {
    const stickyRechargeSelect = document.querySelector('[data-sticky-recharge-select]');
    if (!stickyRechargeSelect) return;
    
    let isSyncing = false;
    
    stickyRechargeSelect.addEventListener('change', (e) => {
      if (isSyncing) return;
      isSyncing = true;
      
      const selectedValue = e.target.value;
      const selectedType = e.target.selectedOptions[0]?.getAttribute('data-type');
      
      if (selectedType === 'onetime') {
        const mainOnetimeOption = Array.from(mainRcOptions).find(opt => 
          opt.querySelector('.rc_widget__option__input--onetime')
        );
        
        if (mainOnetimeOption && !mainOnetimeOption.classList.contains('rc-option--active')) {
          const clickTarget = mainOnetimeOption.querySelector('input[type="radio"]') || mainOnetimeOption;
          clickTarget.click();
        }
        
        if (this.stickySellingPlanInput) {
          this.stickySellingPlanInput.value = '';
        }
        if (this.mainSellingPlanInput) this.mainSellingPlanInput.value = '';
      } else if (selectedType === 'subscription') {
        const savedScrollY = window.scrollY;
        const savedScrollX = window.scrollX;
        
        const mainSubscribeOption = Array.from(mainRcOptions).find(opt => 
          !opt.querySelector('.rc_widget__option__input--onetime')
        );
        
        if (mainSubscribeOption && !mainSubscribeOption.classList.contains('rc-option--active')) {
          const clickTarget = mainSubscribeOption.querySelector('input[type="radio"]') || mainSubscribeOption;
          if (clickTarget.focus) {
            clickTarget.focus({ preventScroll: true });
          }
          clickTarget.click();
        }
        
        requestAnimationFrame(() => {
          window.scrollTo(savedScrollX, savedScrollY);
          
          setTimeout(() => {
            const targetRadio = Array.from(mainRadios).find(radio => radio.value === selectedValue);
            if (targetRadio && !targetRadio.checked) {
              targetRadio.checked = true;
              targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
            
            // Set selling_plan in both forms
            if (this.mainSellingPlanInput) {
              this.mainSellingPlanInput.value = selectedValue;
            }
            if (this.stickySellingPlanInput) {
              this.stickySellingPlanInput.value = selectedValue;
            }
            
            requestAnimationFrame(() => {
              window.scrollTo(savedScrollX, savedScrollY);
              this.updatePriceFromMainForm();
            });
        }, 100);
      });
      }
      
      setTimeout(() => { isSyncing = false; }, 200);
    });
  }

  setupQuantitySync() {
    if (!this.mainQuantityInput || !this.stickyQuantityInput) return;

    const syncToSticky = () => {
      if (this.mainQuantityInput && this.stickyQuantityInput) {
        this.stickyQuantityInput.value = this.mainQuantityInput.value;
      }
    };

    const syncToMain = () => {
      if (this.mainQuantityInput && this.stickyQuantityInput) {
        this.mainQuantityInput.value = this.stickyQuantityInput.value;
      }
    };

    this.mainQuantityInput.addEventListener('change', syncToSticky);
    this.mainQuantityInput.addEventListener('input', syncToSticky);

    this.stickyQuantityInput.addEventListener('change', syncToMain);
    this.stickyQuantityInput.addEventListener('input', syncToMain);

    const mainQuantityBox = this.mainForm?.querySelector('.product-quantity-box') ||
                           document.querySelector('.product_form .product-quantity-box');
    
    if (mainQuantityBox) {
      const mainMinusBtn = mainQuantityBox.querySelector('.product-minus, .js-change-quantity[data-func="minus"]');
      const mainPlusBtn = mainQuantityBox.querySelector('.product-plus, .js-change-quantity[data-func="plus"]');

      if (mainMinusBtn) {
        mainMinusBtn.addEventListener('click', () => {
          setTimeout(syncToSticky, 50);
        });
      }

      if (mainPlusBtn) {
        mainPlusBtn.addEventListener('click', () => {
          setTimeout(syncToSticky, 50);
        });
      }
    }

    let lastMainQuantity = this.mainQuantityInput?.value;
    const checkQuantitySync = () => {
      if (this.mainQuantityInput && this.stickyQuantityInput) {
        const currentMainValue = this.mainQuantityInput.value;
        if (currentMainValue !== lastMainQuantity) {
          lastMainQuantity = currentMainValue;
          syncToSticky();
        }
      }
    };

    if (this.mainQuantityInput) {
      const quantityCheckInterval = setInterval(checkQuantitySync, 150);
      this.quantityCheckInterval = quantityCheckInterval;
    }

    const stickyMinusBtn = this.stickyForm.querySelector('[data-quantity-minus]');
    const stickyPlusBtn = this.stickyForm.querySelector('[data-quantity-plus]');

    if (stickyMinusBtn) {
      stickyMinusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const currentValue = parseInt(this.stickyQuantityInput.value) || 1;
        const newValue = Math.max(1, currentValue - 1);
        
        this.stickyQuantityInput.value = newValue;
        syncToMain();
        this.stickyQuantityInput.dispatchEvent(new Event('change'));
      });
    }

    if (stickyPlusBtn) {
      stickyPlusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const currentValue = parseInt(this.stickyQuantityInput.value) || 1;
        const max = parseInt(this.stickyQuantityInput.getAttribute('max')) || Infinity;
        const newValue = Math.min(max, currentValue + 1);
        
        this.stickyQuantityInput.value = newValue;
        syncToMain();
        this.stickyQuantityInput.dispatchEvent(new Event('change'));
      });
    }
  }

  setupReviewsScroll() {
    const reviewsLink = document.querySelector('[data-scroll-to-reviews]');
    if (!reviewsLink) return;

    reviewsLink.addEventListener('click', (e) => {
      e.preventDefault();
      
      const reviewsSection = document.querySelector('#judgeme_product_reviews') ||
                           document.querySelector('.jdgm-widget') ||
                           document.querySelector('[data-reviews-section]');
      
      if (reviewsSection) {
        reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  hideEmptyReviews() {
    const reviewsContainer = this.stickyBar?.querySelector('.sticky-atc__reviews');
    if (!reviewsContainer) return;

    const checkReviews = () => {
      const badge = reviewsContainer.querySelector('[data-number-of-reviews]');
      const badgeText = reviewsContainer.querySelector('.jdgm-prev-badge__text');
      
      if (badge && badge.getAttribute('data-number-of-reviews') === '0') {
        reviewsContainer.style.display = 'none';
      } else if (badgeText && badgeText.textContent.trim() === 'No reviews') {
        reviewsContainer.style.display = 'none';
      } else {
        reviewsContainer.style.display = '';
      }
    };

    checkReviews();

    const observer = new MutationObserver(checkReviews);
    const badge = reviewsContainer.querySelector('[data-number-of-reviews]');
    if (badge) {
      observer.observe(badge, { attributes: true, attributeFilter: ['data-number-of-reviews'] });
    }
    
    const badgeText = reviewsContainer.querySelector('.jdgm-prev-badge__text');
    if (badgeText) {
      observer.observe(badgeText, { childList: true, characterData: true, subtree: true });
    }

    setTimeout(checkReviews, 500);
    setTimeout(checkReviews, 1000);
  }

  setupPriceObserver() {
    if (this._mainPriceContainer) {
      this.priceObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            this.updatePriceFromMainForm();
            break;
          }
        }
      });
      
      this.priceObserver.observe(this._mainPriceContainer, {
        childList: true,
        characterData: true,
        subtree: true
      });
      return;
    }

    const selectors = [
      '.modal_price .price__container',
      '.product__price-modal .price__container',
      '.modal_price .limoniapps-discountninja-productprice',
      '.product__price-modal .limoniapps-discountninja-productprice',
      '.modal_price .current_price',
      '.product__price-modal .current_price',
      '.price__container .current_price',
      '.limoniapps-discountninja-productprice .current_price'
    ];
    
    for (const selector of selectors) {
      this._mainPriceContainer = document.querySelector(selector);
      if (this._mainPriceContainer) break;
    }
    
    if (!this._mainPriceContainer) return;
    
    this.priceObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          this.updatePriceFromMainForm();
          break;
        }
      }
    });
    
    this.priceObserver.observe(this._mainPriceContainer, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  updatePriceFromMainForm() {
    if (!this.stickyPrice) return;

    const selectors = [
      '.modal_price .current_price',
      '.product__price-modal .current_price',
      '.modal_price .price__container .current_price',
      '.product__price-modal .price__container .current_price',
      '.limoniapps-discountninja-productprice .current_price',
      '.price__container .current_price',
      '.current_price .money',
      '.product-single__price .money'
    ];
    
    if (this._cachedMainPriceElement && this._cachedMainPriceElement.isConnected && this._cachedMainPriceElement.textContent.trim()) {
      this.stickyPrice.textContent = this._cachedMainPriceElement.textContent.trim();
      return;
    }
    
    this._cachedMainPriceElement = null;
    
    for (const selector of selectors) {
      const element = document.querySelector(selector);
      if (element && element.textContent.trim()) {
        this._cachedMainPriceElement = element;
        this.stickyPrice.textContent = element.textContent.trim();
        return;
      }
    }
  }

  cleanup() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
    if (this.priceObserver) {
      this.priceObserver.disconnect();
    }
    if (this.rechargeObserver) {
      this.rechargeObserver.disconnect();
    }
    if (this.customRechargeObserver) {
      this.customRechargeObserver.disconnect();
    }
    
    if (this.quantityCheckInterval) {
      clearInterval(this.quantityCheckInterval);
    }
    
    if (this.sellingPlanCheckInterval) {
      clearInterval(this.sellingPlanCheckInterval);
    }
    
    if (this.rechargeTimeout) {
      clearTimeout(this.rechargeTimeout);
    }

    if (this.rechargeRetryInterval) {
      clearInterval(this.rechargeRetryInterval);
    }
    
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
    
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
    
    if (this.urlChangeHandler) {
      window.removeEventListener('popstate', this.urlChangeHandler);
    }
    
    if (this._originalReplaceState) {
      window.history.replaceState = this._originalReplaceState;
    }
    
    if (this._originalPushState) {
      window.history.pushState = this._originalPushState;
    }
  }

  formatMoney(cents) {
    const format = this.stickyForm?.dataset.moneyFormat || '${{amount}}';
    const value = (parseInt(cents) / 100).toFixed(2);
    return format.replace('{{amount}}', value);
  }
}

function initStickyATC() {
  try {
    return new StickyAddToCart();
  } catch (error) {
    return null;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyATC);
} else {
  initStickyATC();
}

window.StickyAddToCart = StickyAddToCart;
